import { Table } from '@octano/global-ui';
import { useColumns } from '../hooks/useColumns';
import { useTexts } from '../hooks/useTexts';
import { Pagination, PetitionsHistoryResponse } from '../types';

type Props = {
  petitions: PetitionsHistoryResponse['petitions'];
  openModal: Function;
  query: {
    studentId: number;
    pagination: Pagination;
  };
  updateQuery: (
    query?:
      | {
          studentId: number;
          pagination: Pagination;
        }
      | undefined,
  ) => void;
  setPagination: React.Dispatch<React.SetStateAction<Pagination>>;
};
export function PetitionsTable({
  petitions,
  openModal,
  query,
  updateQuery,
  setPagination,
}: Props) {
  const data = petitions.data;
  const formatedPetitions = useColumns(data, openModal);
  const texts = useTexts();

  function changePagination(newPage: number) {
    setPagination({
      items_per_page: query.pagination.items_per_page,
      page: newPage - 1,
    });
    updateQuery({
      ...query,
      pagination: { ...query.pagination, page: newPage - 1 },
    });
  }
  return (
    <>
      <Table
        pagination={{
          currentPage: query.pagination.page + 1,
          itemsPerPage: query.pagination.items_per_page!,
          totalPages: petitions.total_pages,
          onChangePage: (page) => changePagination(page),
          totalItems: petitions.total,
        }}
        data={formatedPetitions}
        noResultsText="No hay solicitudes registradas"
        columns={[
          {
            headerText: texts.table.folio,
            columnName: 'folio',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.createdAt,
            columnName: 'createdAt',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.studyPlanVersionName,
            columnName: 'studyPlanVersionName',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.typeName,
            columnName: 'typeName',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.title,
            columnName: 'title',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.status,
            columnName: 'status',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.paymentStatus,
            columnName: 'paymentStatus',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.viewDetail,
            columnName: 'viewDetail',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
        ]}
      />
    </>
  );
}
